export default __webpack_public_path__ + "static/media/book_ThePaleBlade.e3222a08.jpg";